import MDInput from "components/MDInput";
import React, { useState } from "react";
import PropTypes from "prop-types";
import VerifiedStatus from "components/Custom/VerifiedStatus";
import CustomModal from "examples/Modal/ConfirmationModal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const isEmailValid = (email) => {
  const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return emailPattern.test(email);
};

const SecondaryEmail = ({
  emailData,
  onSendOTP,
  onFieldChange,
  index,
  isConfirmationModal,
  confirmationModalLoader,
  onUnlinked,
}) => {
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);

  const handleClose = () => {
    setIsOpenConfirmationModal(!isOpenConfirmationModal);
  };
  const handleConfirm = () => {
    onUnlinked(index);
  };

  const handleUnlink = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isConfirmationModal) {
      setIsOpenConfirmationModal(true);
    } else {
      onUnlinked(index);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <MDInput
          name="email"
          type="email"
          fullWidth
          value={emailData.email}
          variant="outlined"
          FormHelperTextProps={{
            sx: { ml: "5px", backgroundColor: "white" },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius:
                emailData.email !== "" && isEmailValid(emailData.email) ? "8px 0px 0px 8px" : "8px",
              paddingRight: emailData.email ? "35px" : "14px", // Add padding for the close button
            },
          }}
          disabled={emailData?.disabled || emailData?.isVerified || emailData?.isOTPVisible}
          onChange={(e) => onFieldChange(e, index)}
          error={emailData?.email !== "" && !isEmailValid(emailData.email)}
        />

        {/* Independent Close Icon */}
        {emailData.email && emailData.isOTPVisible && !emailData?.isVerified && (
          <IconButton
            aria-label="clear email"
            onClick={handleUnlink}
            edge="end"
            size="small"
            sx={{
              position: "absolute",
              right: "25%",
              top: "27.3%",
              transform: "translateY(-50%)",
              zIndex: 10,
              backgroundColor: "transparent",
              padding: "4px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.06)",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}

        <div style={{ lineHeight: "16.4px", marginLeft: "2px" }}>
          <span style={{ color: "#535862", fontSize: "13px", fontWeight: 400 }}>
            Secondary email allows you to link your work & personal emails and get reward points
            when you order from either emails.
          </span>
        </div>
      </div>

      {/* VERIFY BUTTON  */}
      {!emailData.isVerified && emailData.email !== "" && isEmailValid(emailData.email) && (
        <button
          type="button"
          onClick={onSendOTP}
          style={{
            backgroundColor: "transparent",
            color: "#414651",
            border: "1px solid #D5D7DA",
            cursor: "pointer",
            padding: "8px 20px",
            fontSize: "15px",
            fontWeight: "600",
            borderRadius: "0px 8px 8px 0px",
            borderLeft: "0px solid",
            textTransform: "none",
            lineHeight: "24px",
            transition: "all 0.2s ease",
            outline: "none",
            height: "44px",
          }}
        >
          Verify
        </button>
      )}
      {/* DELETE BUTTON  */}
      {emailData?.isVerified && isEmailValid(emailData?.email) && (
        <button
          onClick={handleUnlink}
          style={{
            backgroundColor: "transparent",
            color: "#414651",
            border: "1px solid #D5D7DA",
            cursor: "pointer",
            padding: "8px 20px",
            fontSize: "15px",
            fontWeight: "600",
            borderRadius: "0px 8px 8px 0px",
            borderLeft: "0px solid",
            textTransform: "none",
            lineHeight: "24px",
            transition: "all 0.2s ease",
            outline: "none",
            height: "44px",
          }}
        >
          Delete
        </button>
      )}
      {/* VERIFICATION PILL  */}
      {emailData.email !== "" && isEmailValid(emailData.email) && (
        <VerifiedStatus isBtnVisible={true} status={emailData?.isVerified} />
      )}
      {/* MODAL TO CONFIRM DELETE  */}
      <CustomModal
        open={isOpenConfirmationModal}
        handleClose={handleClose}
        color={"success"}
        title={`Are you sure want to unlink?`}
        userEmail={emailData?.email}
        description={
          emailData.isVerified
            ? "Any future orders placed using this email will not be counted."
            : ""
        }
        onConfirm={handleConfirm}
        loader={confirmationModalLoader}
        isIcon={false}
      />
    </>
  );
};

export default SecondaryEmail;

SecondaryEmail.propTypes = {
  emailData: PropTypes.shape({
    email: PropTypes.string,
    isOTPVisible: PropTypes.bool,
    otpNumber: PropTypes.string,
    disabled: PropTypes.bool,
    isVerified: PropTypes.bool,
    isAuthFlow: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onSendOTP: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onVerify: PropTypes.func.isRequired,
  onUnlinked: PropTypes.func.isRequired,
  isSendingOTP: PropTypes.bool,
  isConfirmationModal: PropTypes.any,
  confirmationModalLoader: PropTypes.bool,
  isForgotPassword: PropTypes.bool,
};
